const WithdrawGetter = {
    withdraws: (state) => state.withdraws,
    sends: (state) => state.sends,
    sells: (state) => state.sells,
};

export default WithdrawGetter;